<div class="rate-review-presenter">
    <div class="flex items-center gap-2">
        <button
            pButton
            pRipple
            severity="secondary"
            title="Remove pending rate adjustment"
            label="Cancel Adjustment"
            (click)="Cancel.next()"
            [disabled]="this.cancelDisabled"
        ></button>
        <button
            pButton
            pRipple
            severity="secondary"
            title="Finalize rates and generate rate adjustment invoice"
            label="Commit"
            icon="pi pi-upload"
            (click)="Commit.next(); cancelDisabled = true; commitDisabled = true;"
            [disabled]="this.commitDisabled"
        ></button>
        <button
            pButton
            class="p-button-secondary"
            title="Download"
            pTooltip="Download"
            icon="pi pi-download"
            (click)="onDownload()"
        ></button>
        <span>
            <p-messages [value]="messages"></p-messages>
        </span>
    </div>
    <div class="rate-review-table">
        <p-table stripedRows [value]="items"
            dataKey="id"
            #dataTable
            [scrollable]="true"
            scrollHeight="35vh"
            [columns]="cols"
            [virtualScroll]="true"
            [loading]="loading"
        >
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="10" style="text-align: center">
                        <div class="tabulator-placeholder">
                            <span>
                                Rate adjustment entries are not available.
                            </span>
                        </div>
                    </td>
                </tr>
            </ng-template>
            <ng-template #header let-item>
                <tr>
                    <!-- 'Contract Type' -->
                    <th

                        [pSortableColumn]="'Contract Type'"

                    >
                        Contract Type
                        <p-sortIcon field="'Contract Type'"></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="'Contract Type'" display="menu" class="ml-auto" />
                    </th>
                    <!-- Contract -->
                    <th

                        pSortableColumn="Contract"

                    >
                        Contract
                        <p-sortIcon field="Contract"></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="Contract" display="menu" class="ml-auto" />
                    </th>
                    <!-- Task -->
                    <th

                        pSortableColumn="Task"

                    >
                        Task
                        <p-sortIcon field="Task"></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="Task" display="menu" class="ml-auto" />
                    </th>
                    <!-- PeriodStart -->
                    <th

                        pSortableColumn="PeriodStart"

                    >
                        Period Start
                        <p-sortIcon field="PeriodStart"></p-sortIcon>
                    </th>
                    <!-- PeriodEnd -->
                    <th

                        pSortableColumn="PeriodEnd"

                    >
                        Period End
                        <p-sortIcon field="PeriodEnd"></p-sortIcon>
                    </th>
                    <!-- 'Cost Center' -->
                    <th

                        [pSortableColumn]="'Cost Center'"

                    >
                        Cost Center
                        <p-sortIcon field="'Cost Center'"></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="'Cost Center'" display="menu" class="ml-auto" />
                    </th>
                    <!-- 'Expense Type' -->
                    <th
                        [pSortableColumn]="'Expense Type'"

                    >
                        Cost Type
                        <p-sortIcon field="'Expense Type'"></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="'Expense Type'" display="menu" class="ml-auto" />
                    </th>
                    <!-- 'Service Item' -->
                    <th

                        [pSortableColumn]="'Service Item'"

                    >
                        Service Item
                        <p-sortIcon field="'Service Item'"></p-sortIcon>
                        <p-columnFilter type="text" matchMode="contains" field="'Service Item'" display="menu" class="ml-auto" />
                    </th>
                    <!-- Hours -->
                    <th
                        pSortableColumn="Hours"

                    >
                        Hours
                        <p-sortIcon field="Hours"></p-sortIcon>
                    </th>
                    <!-- Amount -->
                    <th
                        pSortableColumn="Amount"

                    >
                        Amount
                        <p-sortIcon field="Amount"></p-sortIcon>
                    </th>
                    <!-- 'FR Burden' -->
                    <th
                        [pSortableColumn]="'FR Burden'"

                    >
                        FR Burden
                        <p-sortIcon field="'FR Burden'"></p-sortIcon>
                    </th>
                    <!-- 'OH Burden' -->
                    <th
                        [pSortableColumn]="'OH Burden'"

                    >
                        OH Burden
                        <p-sortIcon field="'OH Burden'"></p-sortIcon>
                    </th>
                    <!-- 'Handling Burden' -->
                    <th
                        [pSortableColumn]="'Handling Burden'"

                    >
                        Handling Burden
                        <p-sortIcon field="'Handling Burden'"></p-sortIcon>
                    </th>
                    <!-- 'GA Burden' -->
                    <th
                        [pSortableColumn]="'GA Burden'"

                    >
                        GA Burden
                        <p-sortIcon field="'GA Burden'"></p-sortIcon>
                    </th>
                    <!-- 'Before Fee' -->
                    <th
                        [pSortableColumn]="'Before Fee'"

                    >
                        Before Fee
                        <p-sortIcon field="'Before Fee'"></p-sortIcon>
                    </th>
                    <!-- 'Fee Burden' -->
                    <th
                        [pSortableColumn]="'Fee Burden'"

                    >
                        Fee Burden
                        <p-sortIcon field="'Fee Burden'"></p-sortIcon>
                    </th>
                    <!-- 'Burdened Amount' -->
                    <th
                        [pSortableColumn]="'Burdened Amount'"

                    >
                        Burdened Amount
                        <p-sortIcon field="'Burdened Amount'"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template #body let-item>
                <tr data-id="row-{{ item?.id }}">
                    <!-- 'Contract Type' -->
                    <td

                        [title]="item['Contract Type']"
                    >
                        {{ item['Contract Type'] }}
                    </td>
                    <!-- Contract -->
                    <td

                        [title]="item.Contract"
                    >
                        {{ item.Contract }}
                    </td>
                    <!-- Task -->
                    <td

                        [title]="item.Task"
                    >
                        {{ item.Task }}
                    </td>
                    <!-- PeriodStart -->
                    <td

                        [title]="moment(item.PeriodStart).format('L')"
                    >
                        {{ moment(item.PeriodStart).format('L') }}
                    </td>
                    <!-- PeriodEnd -->
                    <td

                        [title]="moment(item.PeriodEnd).format('L')"
                    >
                        {{ moment(item.PeriodEnd).format('L') }}
                    </td>
                    <!-- 'Cost Center' -->
                    <td

                        [title]="item['Cost Center']"
                    >
                        {{ item['Cost Center'] }}
                    </td>
                    <!-- 'Expense Type' -->
                    <td

                        [title]="item['Expense Type']"
                    >
                        {{ item['Expense Type'] }}
                    </td>
                    <!-- 'Service Item' -->
                    <td

                        [title]="item['Service Item']"
                    >
                        {{ item['Service Item'] }}
                    </td>
                    <!-- Hours -->
                    <td

                        [title]="item.Hours"
                    >
                        {{ item.Hours }}
                    </td>
                    <!-- Amount -->
                    <td
                        class="currency"
                        [title]="item.Amount"
                    >
                        {{ item.Amount | currency }}
                    </td>
                    <!-- 'FR Burden' -->
                    <td
                        class="currency"
                        [title]="item['FR Burden']"
                    >
                        {{ item['FR Burden'] | currency }}
                    </td>
                    <!-- 'OH Burden' -->
                    <td
                        class="currency"
                        [title]="item['OH Burden']"
                    >
                        {{ item['OH Burden'] | currency }}
                    </td>
                    <!-- 'Handling Burden' -->
                    <td
                        class="currency"
                        [title]="item['Handling Burden']"
                    >
                        {{ item['Handling Burden'] | currency }}
                    </td>
                    <!-- 'GA Burden' -->
                    <td
                        class="currency"
                        [title]="item['GA Burden']"
                    >
                        {{ item['GA Burden'] | currency }}
                    </td>
                    <!-- 'Before Fee' -->
                    <td
                        class="currency"
                        [title]="item['Before Fee']"
                    >
                        {{ item['Before Fee'] | currency }}
                    </td>
                    <!-- 'Fee Burden' -->
                    <td
                        class="currency"
                        [title]="item['Fee Burden']"
                    >
                        {{ item['Fee Burden'] | currency }}
                    </td>
                    <!-- 'Burdened Amount' -->
                    <td
                        class="currency"
                        [title]="item['Burdened Amount']"
                    >
                        {{ item['Burdened Amount'] | currency }}
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
